const STORAGE_KEY = "csrp_bcm_service_requests_list_state";

export function saveBcmServiceRequestListState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readBcmServiceRequestListState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearBcmServiceRequestListState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Saved list snapshot when returning from SR detail (pendingRestore flag set). */
export function readBcmServiceRequestListRestoreSnapshot() {
  const saved = readBcmServiceRequestListState();
  if (!saved?.pendingRestore) return null;
  return saved;
}

export function markBcmServiceRequestListPendingRestore() {
  const saved = readBcmServiceRequestListState();
  if (!saved) return;
  saveBcmServiceRequestListState({ ...saved, pendingRestore: true });
}

export function markBcmServiceRequestListRestored() {
  const saved = readBcmServiceRequestListState();
  if (!saved) return;
  saveBcmServiceRequestListState({ ...saved, pendingRestore: false });
}
